const GA = require('../../../modules/ga');

module.exports = {
    props: ['bikeId'],

    data: function () {
        return {
            active: false
        };
    },

    computed: {
        selectedBikeIds: function () {
            return this.$store.state.comparedBikeIds;
        }
    },

    mounted: function () {
        this.active = this.selectedBikeIds.indexOf(this.bikeId) > -1;
    },

    methods: {
        toggleComparison: function () {
            if (this.active) {
                this.$store.commit('removeBikeId', this.bikeId);
                GA.event('compare', 'add', this.bikeId);
            }
            else {
                this.$store.commit('addBikeId', this.bikeId);
                GA.event('compare', 'remove', this.bikeId);
            }

            this.active = !this.active;
        }
    }
};